export function formatDate(strDate) {
  try {
    var strSplitDate = String(strDate).split(" ");
    var date = new Date(strSplitDate[0]);
    var dd = date.getDate();
    var mm = date.getMonth() + 1; //January is 0!

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    date = dd + "/" + mm + "/" + yyyy;
    return date.toString();
  } catch (error) {
    return "";
  }
}
export function process(date) {
  var parts = date.split("/");
  return new Date(parts[2], parts[1] - 1, parts[0]);
}
export function currentDate() {
  let currentDate1 = new Date();
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
export function tomorrowDate() {
  const today = new Date();
  let currentDate1 = new Date(today);
  currentDate1.setDate(today.getDate() + 1);
  var dd = currentDate1.getDate();
  var mm = currentDate1.getMonth() + 1; //January is 0!
  var yyyy = currentDate1.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
export function getDate(date) {
  try {
    if (!date) return "";
    var strSplitDate = String(date).split(" ");
    if (strSplitDate[0].indexOf("0001") > -1) {
      return "";
    }
    var dateNgayVay = new Date(
      strSplitDate[0].replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
    );
    if (dateNgayVay <= new Date(1900, 1, 1, 0, 0, 0, 0)) {
      return "";
    }
    return strSplitDate[0];
  } catch (error) {
    return "";
  }
}
export function convertDate(date) {
  if (date) {
    var strSplitDate = String(date).split(" ");
    var strDate = strSplitDate[0].replace(
      /(\d{2})\/(\d{2})\/(\d{4})/,
      "$2/$1/$3"
    );
    if (strDate.indexOf("1900") > -1) return null;
    var dateNgayVay = new Date(strDate);
    return dateNgayVay;
  } else {
    return "";
  }
}
export function formatDateTime(date) {
  var year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate();
  return day + "/" + month + "/" + year;
}
export function formatDayMonth(date) {
  if (date) {
    var year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate();
    if (month < 10 && day < 10) {
      return "0" + day + "/" + "0" + month + "/" + year;
    }
    if (month >= 10 && day >= 10) {
      return day + "/" + month + "/" + year;
    }
    if (month >= 10 && day < 10) {
      return "0" + day + "/" + month + "/" + year;
    }
    if (month < 10 && day >= 10) {
      return day + "/" + "0" + month + "/" + year;
    }
  } else {
    return "";
  }
}

// return an array of date objects for start (monday)
// and end (sunday) of week based on supplied
// date object or current date
export const startAndEndOfWeek = (date) => {
  // If no date object supplied, use current date
  // Copy date so don't modify supplied date
  var now = date ? new Date(date) : new Date();

  // set time to some convenient value
  now.setHours(0, 0, 0, 0);

  // Get the previous Monday
  var monday = new Date(now);
  monday.setDate(monday.getDate() - monday.getDay() + 1);

  // Get next Sunday
  var sunday = new Date(now);
  sunday.setDate(sunday.getDate() - sunday.getDay() + 7);

  // Return array of date objects
  return [monday, sunday];
};
export const startAndEndOfMonth = (date) => {
  var now = date ? new Date(date) : new Date();
  var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  var lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return [firstDay, lastDay];
};

export const startAndEndOfYear = (date) => {
  var now = date ? new Date(date) : new Date();
  var firstDay = new Date(now.getFullYear(), 0, 1);
  var lastDay = new Date(now.getFullYear(), 11, 31);
  return [firstDay, lastDay];
};

export const calculateSum = (obj, field) =>
  obj.map((items) => items[field]).reduce((prev, curr) => prev + curr, 0);
export const convertFloat = (value) => {
  try {
    value = value.replace(/,/g, "");
    return parseFloat(value);
  } catch (error) {
    return 0;
  }
};
export const convertToNumber = (text) => {
  return text ? parseFloat((text + "").replace(/,/g, "")) : 0;
};
export const convertToNumber2 = (text) => {
  return text ? parseFloat((text + "").replace(/,/g, "")).toFixed(2) : 0;
};
// Code format . , cũ của chị Hằng
// export const formatNumber = (inputNumber) => {
//   let formetedNumber = Number(inputNumber)
//     .toFixed(2)
//     .replace(/\d(?=(\d{3})+\.)/g, "$&,");
//   let splitArray = formetedNumber.split(".");
//   if (splitArray.length > 1) {
//     formetedNumber = splitArray[0];
//   }
//   return formetedNumber;
// };
const getFormatConfig = () => {
  try {
    const config = localStorage.getItem("numberFormatConfig");
    return config ? JSON.parse(config) : null;
  } catch {
    return null;
  }
};

const config = getFormatConfig();
// Đổi sang code format chuẩn quốc tế hoặc việt nam dùng toLocaleString
export const formatNumber = (inputNumber) => {
  if (inputNumber == null || inputNumber === "") return "";

  const num = Number(inputNumber);

  // Nếu không parse được thành số thì trả lại chuỗi gốc
  if (isNaN(num)) return inputNumber;

  let locale = "en-US";
  if (config && config.decimalSeparator === ",") {
    locale = "de-DE";
  }

  return num.toLocaleString(locale);
};

export const formatNumber2Digits = (inputNumber, digits) => {
  return +(Math.round(inputNumber + "e+" + digits) + "e-" + digits);
};
export const CustomerParseFloat = (value) => {
  if (value == null) return NaN;

  let cauhinh = 1; // mặc định dấu thập phân là "."
  if (config && config.decimalSeparator === ",") {
    cauhinh = 2; // cấu hình dấu thập phân là ","
  }

  try {
    if (typeof value === "string") {
      let cleaned = value.trim();

      if (cauhinh === 2) {
        // Kiểu Việt Nam / EU: "." là nghìn, "," là thập phân
        cleaned = cleaned
          .replace(/\.(?=\d{3}(?:,|$))/g, "") // xóa dấu . nếu là dấu nghìn
          .replace(",", ".");
      } else if (cauhinh === 1) {
        // Kiểu US: "," là nghìn, "." là thập phân
        cleaned = cleaned.replace(/,(?=\d{3}(?:\.|$))/g, ""); // xóa dấu , nếu là dấu nghìn
      }

      const parsed = Number.parseFloat(cleaned);
      if (Number.isNaN(parsed)) return value; // trả về string gốc nếu không parse được

      return Number(parsed.toFixed(4)); // giới hạn 4 chữ số thập phân
    }

    if (typeof value === "number") {
      return Number(value.toFixed(4));
    }

    if (typeof value === "object") {
      if (typeof value.value === "function")
        return Number(value.value().toFixed(4));
      if (typeof value.valueOf === "function")
        return Number(value.valueOf().toFixed(4));
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? value : Number(parsed.toFixed(4));
  } catch (err) {
    // Nếu lỗi ở bất kỳ đâu thì trả về string gốc
    return value;
  }
};
